import { PortfolioFarmPosition } from 'types/portfolio'

export function getFarmPositionTotalValue(position: PortfolioFarmPosition): number {
  if (position.isSingleFarm) {
    const staked = Number(position.formattedStakedAmount || 0)
    const wallet = Number(position.formattedWalletBalance || 0)
    const tokenPrice = position.farm.stakingToken.price || 0
    return (staked + wallet) * tokenPrice
  }

  return position.stakedAmountUSD + (position.walletBalanceUSD || 0)
}
